
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4BeGP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $38vK5 = parcelRequire("38vK5");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");

// Source: https://github.com/atlassian/react-beautiful-dnd
const $62fb89270622ea6f$var$isEqual = (base)=>(value)=>base === value;
const $62fb89270622ea6f$var$isScroll = $62fb89270622ea6f$var$isEqual('scroll');
const $62fb89270622ea6f$var$isAuto = $62fb89270622ea6f$var$isEqual('auto');
const $62fb89270622ea6f$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $62fb89270622ea6f$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $62fb89270622ea6f$var$isEither(overflow, $62fb89270622ea6f$var$isScroll) || $62fb89270622ea6f$var$isEither(overflow, $62fb89270622ea6f$var$isAuto);
};
const $62fb89270622ea6f$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (el === document.body || el === document.documentElement) return null;
    if (!$62fb89270622ea6f$var$isElementScrollable(el)) // keep recursing
    return $62fb89270622ea6f$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};











// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77108394ea005630$var$TreeListItemLi = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _2XsHFMdnbC _2Zuz6QdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77108394ea005630$var$DraggableDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77108394ea005630$var$TreeItemBaseInner = (t0, ref)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, item: item, renderItem: renderItem, indentPerLevel: indentPerLevel, currentLevel: currentLevel, isExpanded: isExpanded, onExpand: onExpand, onCollapse: onCollapse, dropIndicator: dropIndicator, dragHandleProps: dragHandleProps, draggableState: draggableState, renderAsTreeRole: renderAsTreeRole } = t0;
    const containerLiRef = (0, $cozmU.useRef)(null);
    const draggableDivRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>({
                containerLiRef: containerLiRef,
                draggableDivRef: draggableDivRef
            });
        $[0] = t1;
    } else t1 = $[0];
    (0, $cozmU.useImperativeHandle)(ref, t1);
    const indent = indentPerLevel * currentLevel;
    let t2;
    if ($[1] !== renderAsTreeRole) {
        t2 = renderAsTreeRole && {
            role: "treeitem"
        };
        $[1] = renderAsTreeRole;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== item.data || $[4] !== item.hasChildren || $[5] !== item.isExpanded) {
        t3 = (item.hasChildren || item.data.type === "folder") && {
            "aria-expanded": item.isExpanded
        };
        $[3] = item.data;
        $[4] = item.hasChildren;
        $[5] = item.isExpanded;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== dragHandleProps || $[8] !== draggableState || $[9] !== indent || $[10] !== item || $[11] !== onCollapse || $[12] !== onExpand || $[13] !== renderItem) {
        t4 = renderItem({
            item: item,
            indent: indent,
            onExpand: onExpand,
            onCollapse: onCollapse,
            draggableState: draggableState,
            dragHandleProps: dragHandleProps
        });
        $[7] = dragHandleProps;
        $[8] = draggableState;
        $[9] = indent;
        $[10] = item;
        $[11] = onCollapse;
        $[12] = onExpand;
        $[13] = renderItem;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== dropIndicator || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($77108394ea005630$var$DraggableDiv, {
            ref: draggableDivRef,
            "data-testid": "tree-item-draggable"
        }, t4, dropIndicator);
        $[15] = dropIndicator;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    const t6 = isExpanded ? children : null;
    let t7;
    if ($[18] !== t2 || $[19] !== t3 || $[20] !== t5 || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($77108394ea005630$var$TreeListItemLi, {
            ref: containerLiRef,
            ...t2,
            ...t3
        }, t5, t6);
        $[18] = t2;
        $[19] = t3;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    return t7;
};
const $77108394ea005630$export$82d65614150df752 = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)($77108394ea005630$var$TreeItemBaseInner));






var $bB0i2 = parcelRequire("bB0i2");


var $9kbTQ = parcelRequire("9kbTQ");


var $cDMxg = parcelRequire("cDMxg");


var $fYWmN = parcelRequire("fYWmN");


var $1zKNa = parcelRequire("1zKNa");


var $fl787 = parcelRequire("fl787");







parcelRequire("j6wrK");
var $2z8iy = parcelRequire("2z8iy");

function $0c2ca567754aefd0$export$1391212d75b2ee65({ fn: fn, time: time }) {
    let timeoutId = window.setTimeout(()=>{
        timeoutId = null;
        fn();
    }, time);
    return function cleanup() {
        if (timeoutId) {
            window.clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
}



var $iIYTj = parcelRequire("iIYTj");


function $e482a439c547ced1$var$getItemMode(isLastInGroup, item) {
    if (item.isExpanded && item.hasChildren) return 'expanded';
    else if (isLastInGroup) return 'last-in-group';
    return 'standard';
}
const $e482a439c547ced1$var$getParentLevelOfInstruction = (instruction)=>{
    if (instruction.type === 'instruction-blocked') return $e482a439c547ced1$var$getParentLevelOfInstruction(instruction.desired);
    if (instruction.type === 'reparent') return instruction.desiredLevel - 1;
    return instruction.currentLevel - 1;
};
/** Using a shared object for the 'idle'
 *
 * This is done so that when a component calls `setDraggableState(idle)`,
 * the component to re-render if it is already in the idle state.
 *
 * We _could_ create a new `idle` object per component:
 *
 * `const idle = useMemo(() => ({ type: "idle" }), []);`
 *
 * But, sharing the same `idle` object between components works well
 * and does not require any additional `useMemo` work by react.
 */ const $e482a439c547ced1$var$idle = {
    type: 'idle'
};
const $e482a439c547ced1$var$parentOfInstruction = {
    type: 'parent-of-instruction'
};
const $e482a439c547ced1$var$TreeItemDraggableInner = ({ onDragStart: onDragStart, onDragEnd: onDragEnd, dragPreview: dragPreview, index: index, isLastInGroup: isLastInGroup, path: path, itemType: itemType, isDragEnabled: isDragEnabled, onDragBlocked: onDragBlocked, renderItem: renderItem, ...baseProps })=>{
    const { item: item, indentPerLevel: indentPerLevel, currentLevel: currentLevel, onExpand: onExpand, onCollapse: onCollapse } = baseProps;
    const { parentId: parentId } = path[currentLevel];
    const [draggableState, setDraggableState] = (0, $cozmU.useState)($e482a439c547ced1$var$idle);
    const [dropIndicatorInstruction, setDropIndicatorInstruction] = (0, $cozmU.useState)(null);
    const isDragDisabled = !isDragEnabled || typeof isDragEnabled === 'function' && !isDragEnabled(item);
    const ref = (0, $cozmU.useRef)(null);
    const cancelDelayedFn = (0, $cozmU.useRef)(null);
    const clearParentOfState = (0, $cozmU.useCallback)(()=>{
        setDraggableState((current)=>current.type === 'parent-of-instruction' ? $e482a439c547ced1$var$idle : current);
    }, []);
    const makeDraggable = (0, $cozmU.useCallback)((el)=>(0, $iSrRp.draggable)({
            element: el,
            canDrag: ()=>{
                if (isDragDisabled) {
                    onDragBlocked?.(item);
                    return false;
                }
                return true;
            },
            onGenerateDragPreview: ({ source: source, nativeSetDragImage: nativeSetDragImage })=>{
                (0, $2z8iy.scrollJustEnoughIntoView)({
                    element: source.element
                });
                (0, $cDMxg.setCustomNativeDragPreview)({
                    getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        // this will cause a sync re-render to add a portal
                        setDraggableState({
                            type: 'generate-preview',
                            container: container
                        });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                /**
       * - If item is expanded, we will collapse the item when the drag starts: an item cannot drag and drop on itself
       * - We make this visual change onDragStart instead of onGenerateDragPreview in order to keep the ref
       *   in a stable position. Otherwise, the collapse can falsely trigger a drop near the bottom of a scrollable container.
       */ if (item.isExpanded) onCollapse?.(item.id);
                setDraggableState({
                    type: 'dragging'
                });
                onDragStart?.();
            },
            getInitialData: ()=>({
                    id: item.id,
                    isExpandedBeforeDrag: item.isExpanded,
                    type: itemType
                }),
            onDrop: ({ location: location, source: source_0 })=>{
                setDraggableState($e482a439c547ced1$var$idle);
                // Skip tree move logic for non-tree-item drags (e.g., smart-link drops from editor)
                if (source_0.data.type !== itemType) return;
                if (location?.current?.dropTargets[0]) {
                    const { data: target } = location.current.dropTargets[0];
                    const instruction = (0, $1zKNa.extractInstruction)(target);
                    if (!target || !target.id || target.type !== itemType || !instruction || // only allow an item to drop on itself if it's being reparented
                    target.id === item.id && instruction.type !== 'reparent') return;
                    /**
         * If the instruction was blocked, calculate the move for the *desired* instruction.
         * Ultimately, we call onDragEnd with the desired move, allowing consumers to handle the move even if it's blocked.
         */ const desiredInstruction = instruction.type === 'instruction-blocked' ? instruction.desired : instruction;
                    let destinationPosition;
                    switch(desiredInstruction.type){
                        case 'reorder-above':
                            destinationPosition = {
                                parentId: target.parentId,
                                index: target.index
                            };
                            break;
                        case 'reorder-below':
                            destinationPosition = {
                                parentId: target.parentId,
                                index: target.index + 1
                            };
                            break;
                        case 'make-child':
                            /**
             * For now, we treat this instruction as a "combine" action:
             * How to do a "combine" action:
             *  1. Set the index to undefined.
             *  2. Page tree will call the movePageAppend mutation, adding it to the END of the list.
             *
             * There is no movePagePrepend mutation at the moment. So, in order to move an item to the beginning
             * (position 0) of a list, we have to know the id of the page that currently occupies position 0 and call
             * movePageBefore. In the case of an unexpanded parent, we do not know the id of the page in position 0.
             */ destinationPosition = {
                                parentId: target.id,
                                index: undefined
                            };
                            break;
                        case 'reparent':
                            /**
             * 1. By using the desired level from the instruction, we can find the position of the target's ancestor.
             * 2. Increment the index to place the item after the target's ancestor.
             */ const destinationSibling = target.path[desiredInstruction.desiredLevel];
                            destinationPosition = {
                                parentId: destinationSibling.parentId,
                                index: destinationSibling.index + 1
                            };
                            break;
                    }
                    // Move item down within same parent. Can happen during reordering or reparenting.
                    if (parentId === destinationPosition.parentId && typeof destinationPosition.index === 'number' && index < destinationPosition.index) destinationPosition.index--;
                    const sourcePosition = {
                        parentId: parentId,
                        index: index
                    };
                    onDragEnd(sourcePosition, destinationPosition, instruction.type);
                }
                // we want to re-expand the item when dropped if it was expanded when the drag started
                if (source_0.data.isExpandedBeforeDrag) onExpand?.(item.id);
            }
        }), [
        onDragStart,
        onDragEnd,
        item,
        index,
        parentId,
        onExpand,
        onCollapse,
        itemType,
        isDragDisabled,
        onDragBlocked
    ]);
    const makeDropTarget = (0, $cozmU.useCallback)((el_0)=>(0, $iSrRp.dropTargetForElements)({
            element: el_0,
            canDrop: ({ source: source_1 })=>{
                return source_1.data.type === itemType || (0, $iIYTj.isSmartLinkDrag)(source_1.data.type);
            },
            getData: ({ input: input, element: element })=>{
                const data = {
                    id: item.id,
                    type: itemType,
                    parentId: parentId,
                    index: index,
                    hasChildren: item.hasChildren,
                    path: path
                };
                return (0, $1zKNa.attachInstruction)(data, {
                    input: input,
                    element: element,
                    currentLevel: currentLevel,
                    indentPerLevel: indentPerLevel,
                    mode: $e482a439c547ced1$var$getItemMode(isLastInGroup, item),
                    block: item.blockedInstructions
                });
            },
            onDrag: ({ self: self, source: source_2, location: location_0 })=>{
                const instruction_0 = (0, $1zKNa.extractInstruction)(self.data);
                if (// only show the drag indicator when dragging over the item being dragged in the case of reparenting
                (source_2.data.id !== item.id || instruction_0?.type === 'reparent') && location_0?.current?.dropTargets[0]?.data?.id === item.id) {
                    // special condition for empty folders to not show the drop indicator before the 'empty' text
                    if (item.data.type === 'folder' && !item.hasChildren && item.isExpanded && instruction_0?.type === 'reorder-below') setDropIndicatorInstruction(null);
                    else {
                        if (item.hasChildren) {
                            if (instruction_0?.type === 'make-child' && !item.isExpanded && !cancelDelayedFn.current) cancelDelayedFn.current = (0, $0c2ca567754aefd0$export$1391212d75b2ee65)({
                                time: 500,
                                fn: ()=>{
                                    onExpand?.(item.id);
                                    // set `cancelDelayedFn` to `null` so we know there is no delayed fn running
                                    cancelDelayedFn.current = null;
                                }
                            });
                            else if (instruction_0?.type !== 'make-child') {
                                cancelDelayedFn.current?.();
                                cancelDelayedFn.current = null;
                            }
                        }
                        setDropIndicatorInstruction(instruction_0);
                    }
                } else setDropIndicatorInstruction(null);
            },
            onDragLeave: ()=>{
                cancelDelayedFn.current?.();
                cancelDelayedFn.current = null;
                setDropIndicatorInstruction(null);
            },
            onDrop: ()=>{
                cancelDelayedFn.current?.();
                cancelDelayedFn.current = null;
                setDropIndicatorInstruction(null);
            }
        }), [
        path,
        item,
        index,
        currentLevel,
        indentPerLevel,
        isLastInGroup,
        parentId,
        onExpand,
        itemType
    ]);
    const isParentOfInstruction = (0, $cozmU.useCallback)((location_1)=>{
        const target_0 = location_1.current.dropTargets[0];
        if (!target_0) return false;
        const instruction_1 = (0, $1zKNa.extractInstruction)(target_0.data);
        if (!instruction_1) return false;
        const targetId = target_0.data.id;
        (0, $bB0i2.default)(typeof targetId === 'string');
        // Dragging over the item being dragged
        if (targetId === item.id) return false;
        const parentLevel = $e482a439c547ced1$var$getParentLevelOfInstruction(instruction_1);
        return currentLevel === parentLevel;
    }, [
        item.id,
        currentLevel
    ]);
    /**
   * We highlight the parent of a drag operation instruction to help make it clearer what level the instruction applies to.
   * We are making the `container li` a `dropTarget` so that it picks up any drag activity for itself AND all of its children
   */ const makeParentOfDropTarget = (0, $cozmU.useCallback)((el_1)=>{
        function onUpdate({ location: location_2 }) {
            if (isParentOfInstruction(location_2)) {
                setDraggableState($e482a439c547ced1$var$parentOfInstruction);
                return;
            }
            clearParentOfState();
        }
        return (0, $iSrRp.dropTargetForElements)({
            element: el_1,
            onDragStart: onUpdate,
            onDragEnter: onUpdate,
            onDrag: onUpdate,
            onDrop () {
                clearParentOfState();
            },
            onDragLeave () {
                clearParentOfState();
            }
        });
    }, [
        isParentOfInstruction,
        clearParentOfState
    ]);
    (0, $cozmU.useEffect)(()=>{
        const draggableEl = ref.current?.draggableDivRef.current;
        (0, $bB0i2.default)(draggableEl);
        const containerEl = ref.current?.containerLiRef.current;
        (0, $bB0i2.default)(containerEl);
        const dropTarget = (0, $aDtKq.combine)(makeDropTarget(draggableEl), makeParentOfDropTarget(containerEl));
        // makeDraggable is always registered; canDrag handles the disabled case
        // (returns false and fires onDragBlocked when appropriate).
        return (0, $aDtKq.combine)(makeDraggable(draggableEl), dropTarget);
    }, [
        makeDraggable,
        makeDropTarget,
        makeParentOfDropTarget
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>cancelDelayedFn.current?.();
    }, []);
    const dropIndicator = dropIndicatorInstruction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fl787.DropIndicator), {
        instruction: dropIndicatorInstruction
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $77108394ea005630$export$82d65614150df752), {
        ref: ref,
        dragHandleProps: {
            draggable: false
        },
        dropIndicator: dropIndicator,
        draggableState: draggableState.type,
        renderItem: renderItem,
        ...baseProps
    }), draggableState.type === 'generate-preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, dragPreview?.(item) || renderItem({
        item: item,
        draggableState: 'generate-preview'
    })), draggableState.container) : null);
};
const $e482a439c547ced1$export$99f16d89b51266cb = /*#__PURE__*/ (0, $cozmU.memo)($e482a439c547ced1$var$TreeItemDraggableInner);


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f69cebdec88d9ef$var$TreeItemUl = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0aNu0LYbGa _2XsHFMdnbC _2Zuz6QdnbC _39xV02N91d _3c7sZndnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $9f69cebdec88d9ef$var$noop = ()=>{};
const $9f69cebdec88d9ef$var$Child = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== t0) {
        const { item: item, pathToParent: pathToParent, parentId: parentId, index: index, parentLevel: parentLevel, isLastInGroup: isLastInGroup, TreeItemComponent: TreeItemComponent, ...shared } = t0;
        let t2;
        if ($[2] !== index || $[3] !== parentId) {
            t2 = {
                parentId: parentId,
                index: index
            };
            $[2] = index;
            $[3] = parentId;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== pathToParent || $[6] !== t2) {
            t3 = [
                ...pathToParent,
                t2
            ];
            $[5] = pathToParent;
            $[6] = t2;
            $[7] = t3;
        } else t3 = $[7];
        const path = t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TreeItemComponent, {
            key: `tree-item-${item.id}`,
            item: item,
            renderItem: shared.renderItem,
            indentPerLevel: shared.indentPerLevel,
            currentLevel: parentLevel,
            isExpanded: item.isExpanded,
            onExpand: shared.onExpand,
            onCollapse: shared.onCollapse,
            renderAsTreeRole: shared.renderAsTreeRole,
            index: index,
            isLastInGroup: isLastInGroup,
            path: path,
            onDragStart: shared.onDragStart ?? $9f69cebdec88d9ef$var$noop,
            onDragEnd: shared.onDragEnd ?? $9f69cebdec88d9ef$var$noop,
            dragPreview: shared.dragPreview,
            isDragEnabled: shared.isDragEnabled,
            onDragBlocked: shared.onDragBlocked,
            itemType: shared.itemType ?? "tree-item"
        }, item.children.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9f69cebdec88d9ef$var$Parent, {
            parent: item,
            currentPath: path,
            TreeItemComponent: TreeItemComponent,
            ...shared
        }) : shared.renderItemEmptyState?.({
            item: item,
            indent: shared.indentPerLevel * parentLevel + shared.indentPerLevel + 24
        }));
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $9f69cebdec88d9ef$var$Parent = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(14);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== ref || $[1] !== t0) {
        t5 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const { parent: parent, currentPath: currentPath, ...shared } = t0;
            if (parent.children.length === 0) {
                t5 = null;
                break bb0;
            }
            const parentLevel = currentPath.length;
            T0 = $9f69cebdec88d9ef$var$TreeItemUl;
            t1 = "tree-item-ul";
            t2 = ref;
            t3 = shared.renderAsTreeRole && {
                role: parentLevel === 0 ? "tree" : "group"
            };
            t4 = parent.children.map((childId, index, array)=>{
                const item = shared.tree.items?.[childId];
                return item && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9f69cebdec88d9ef$var$Child, {
                    key: `tree-item-${item?.id}`,
                    item: item,
                    pathToParent: currentPath,
                    parentLevel: parentLevel,
                    parentId: parent.id,
                    index: index,
                    isLastInGroup: index === array.length - 1,
                    ...shared
                }) || null;
            });
        }
        $[0] = ref;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
        t5 = $[7];
    }
    if (t5 !== Symbol.for("react.early_return_sentinel")) return t5;
    let t6;
    if ($[8] !== T0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            "data-vc": t1,
            ref: t2,
            ...t3
        }, t4);
        $[8] = T0;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
});
const $9f69cebdec88d9ef$export$7fbedc92909ed28e = (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const TreeItemComponent = props.isDragEnabled ? (0, $e482a439c547ced1$export$99f16d89b51266cb) : (0, $77108394ea005630$export$82d65614150df752);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [path] = (0, $cozmU.useState)(t0);
    const ref = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            let cleanupAutoScroll = null;
            return (0, $aDtKq.combine)((0, $iSrRp.monitorForElements)({
                onDragStart: ()=>{
                    if (cleanupAutoScroll) return;
                    const closestScrollable = (0, $62fb89270622ea6f$export$f39f407dd5a0ebdb)(ref.current);
                    if (!closestScrollable) return;
                    cleanupAutoScroll = (0, $38vK5.autoScrollForElements)({
                        element: closestScrollable,
                        canScroll: $9f69cebdec88d9ef$var$_temp
                    });
                },
                canMonitor: $9f69cebdec88d9ef$var$_temp2
            }), ()=>cleanupAutoScroll?.());
        };
        t2 = [];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const root = props.tree.rootId ? props.tree.items[props.tree.rootId] : null;
    if (!root) return null;
    let t3;
    if ($[3] !== TreeItemComponent || $[4] !== path || $[5] !== props || $[6] !== root) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9f69cebdec88d9ef$var$Parent, {
            ref: ref,
            parent: root,
            currentPath: path,
            TreeItemComponent: TreeItemComponent,
            ...props
        });
        $[3] = TreeItemComponent;
        $[4] = path;
        $[5] = props;
        $[6] = root;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
function $9f69cebdec88d9ef$var$_temp(t0) {
    const { source: source } = t0;
    return source.data.type === "tree-item";
}
function $9f69cebdec88d9ef$var$_temp2(t0) {
    const { source: source_0 } = t0;
    return source_0.data.type === "tree-item";
}
module.exports["Tree"] = $9f69cebdec88d9ef$export$7fbedc92909ed28e;

});

parcelRegister("j6wrK", function(module, exports) {
$parcel$export(module.exports, "scrollJustEnoughIntoView", () => (parcelRequire("2z8iy")).scrollJustEnoughIntoView);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { scrollJustEnoughIntoView } from '@atlaskit/pragmatic-drag-and-drop/utils/scroll-just-enough-into-view'` instead.
 */ 
var $2z8iy = parcelRequire("2z8iy");


});

parcelRegister("2z8iy", function(module, exports) {
/**
 * Scroll an `element` just enough into view so that the element becomes totally visible.
 * If the element is already totally visible then no scrolling will occur.
 */ function $d89c19cae0f4a10e$export$2725ea6c83710b1f({ element: element }) {
    element.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
    });
}
module.exports["scrollJustEnoughIntoView"] = $d89c19cae0f4a10e$export$2725ea6c83710b1f;

});


//# sourceMappingURL=MovePageDialog.ec3c1866.js.map
